import React, { useState } from 'react';

export default function AuthGate({ pb, roomId, onSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [authError, setAuthError] = useState('');
  const [authMode, setAuthMode] = useState('password'); // 'password' or 'otp'
  const [otpId, setOtpId] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setAuthError('');
    try {
      await pb.collection('users').authWithPassword(email, password);
      onSuccess(pb.authStore.record);
    } catch (err) {
      setAuthError('Authentication failed. Check your email or password.');
    }
  };

  const handleRequestOTP = async (e) => {
    e.preventDefault();
    setAuthError('');
    setSuccessMsg('');
    try {
      const resultData = await pb.collection('users').requestOTP(email);
      setOtpId(resultData.otpId);
      setSuccessMsg('OTP code sent to your email! Check your inbox.');
    } catch (err) {
      setAuthError('Failed to send OTP. Ensure the email exists.');
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setAuthError('');
    try {
      await pb.collection('users').authWithOTP(otpId, otpCode);
      onSuccess(pb.authStore.record);
    } catch (err) {
      setAuthError('Invalid or expired OTP code.');
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '60px auto', padding: '25px', border: '1px solid #ccc', borderRadius: '8px' }}>
      <h2>Podcast Room Sign-In</h2>
      <p style={{ color: '#666', fontSize: '14px' }}>Please sign in to join session <strong>{roomId}</strong></p>

      {authError && <div style={{ color: '#d9534f', marginBottom: '12px', fontSize: '13px' }}>{authError}</div>}
      {successMsg && <div style={{ color: '#5cb85c', marginBottom: '12px', fontSize: '13px' }}>{successMsg}</div>}

      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <button 
          type="button" 
          onClick={() => { setAuthMode('password'); setAuthError(''); setSuccessMsg(''); }}
          style={{ flex: 1, padding: '6px', background: authMode === 'password' ? '#0275d8' : '#e0e0e0', color: authMode === 'password' ? '#fff' : '#333', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
        >
          Use Password
        </button>
        <button 
          type="button" 
          onClick={() => { setAuthMode('otp'); setAuthError(''); setSuccessMsg(''); }}
          style={{ flex: 1, padding: '6px', background: authMode === 'otp' ? '#0275d8' : '#e0e0e0', color: authMode === 'otp' ? '#fff' : '#333', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
        >
          Fast Email OTP
        </button>
      </div>

      {authMode === 'password' ? (
        <form onSubmit={handleLogin} autoComplete="off">
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }} />
          </div>
          <button type="submit" style={{ width: '100%', padding: '10px', background: '#0275d8', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
            Sign In & Join Room
          </button>
        </form>
      ) : (
        <div>
          {!otpId ? (
            <form onSubmit={handleRequestOTP}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>Enter Your Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }} />
              </div>
              <button type="submit" style={{ width: '100%', padding: '10px', background: '#f0ad4e', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                Send OTP Code
              </button>
            </form>
          ) : (
            <form onSubmit={handleVerifyOTP}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>Enter 6-Digit OTP Code</label>
                <input type="text" value={otpCode} onChange={(e) => setOtpCode(e.target.value)} required placeholder="123456" style={{ width: '100%', padding: '8px', boxSizing: 'border-box', letterSpacing: '2px', textAlign: 'center', fontSize: '16px' }} />
              </div>
              <button type="submit" style={{ width: '100%', padding: '10px', background: '#5cb85c', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                Verify Code & Join
              </button>
            </form>
          )}
        </div>
      )}
    </div>
  );
}